// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListItemStatus-modulegenerating__UT8fB";
var _2 = "GretaAIChatChatListItemStatus-modulenewReply__BpnM3";
export { _1 as "generating", _2 as "newReply" }
